import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const GameHorror = (props) => {

console.log(props.gameData);
    
    return (
        <Link  className={`${styles.gameCardMain}`} to={"/games-horror/:" + props.gameData.id}
         style={{
                backgroundImage: `url("/pictures/backgrounds/${props.gameData.background}.png")`,
                backgroundColor: `rgba(0, 63, 63, 0.295)`
            }}
        >   <div className={`${styles.blackout}`}></div>
            <div className={`${styles.gameCardIcon}`}
            style={{
                background: `url("/pictures/icons/${props.icon}.png") center/cover no-repeat`,
                backgroundColor: `rgba(0, 63, 63, 0.295)`
            }}
            ></div>
              
            <div className={`${styles.gameCardTitle}`}>{props.title}</div>
      
        </Link>
    );
}


export default GameHorror;